/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1576
 */

"use strict"

var r = require(/* 1577 */"./1577")
function i() {}
function o() {}
o.resetWarningCache = i
module.exports = function () {
  function e(e, t, n, i, o, a) {
    if (a !== r) {
      var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")
      s.name = "Invariant Violation"
      throw s
    }
  }
  function t() {
    return e
  }
  e.isRequired = e
  var n = {
    array: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: o,
    resetWarningCache: i
  }
  n.PropTypes = n
  return n
}
